import React from "react";
import { useGameFiles } from "@seabrookstudios/pitch2table";
import { useGameIdFromRoute } from "../games/WithGameIdFromRoute";
import { idExtractor, useMakeListAndDetail, useMakeListBuilder } from "../core/useMakeLayout";
import { Path } from "../Path";
import { Empty } from "./Empty";
import Add from "./Add";
import { ListEntry } from "./ListEntry";
import { FromRoute } from "./FromRoute";
import { GameAssetFilters } from "@seabrookstudios/pitch2table-core";
import { NonMemberUpgradeHeader } from "./NonMemberUpgradeHeader";

export const ListAndDetail = () => {
  const gameId = useGameIdFromRoute();

  const Action = () => <Add gameId={gameId} />;

  const useMakeList = useMakeListBuilder(
    ListEntry,
    idExtractor,
    "Files",
    Empty,
    Action,
    NonMemberUpgradeHeader,
    Path.game(gameId).link(),
    false
  );

  const useWrappedQuery = () => useGameFiles(gameId);

  const ListAndDetail = useMakeListAndDetail(useWrappedQuery, GameAssetFilters, "files", useMakeList, FromRoute);

  return <ListAndDetail />;
};
